export default {
  lstWatchlist: {
    ticker: 'MÃ',
    anDate: 'NGÀY THÔNG BÁO',
    title: 'TIÊU ĐỀ',
    recordDate: 'NGÀY ĐKCC',
    ex: 'NGÀY GDKHQ',
    excercise: 'NGÀY THỰC HIỆN',
    eventType: 'LOẠI SỰ KIỆN',
    reference: 'THAM CHIẾU',
  },
  lstTitleDate: {
    anDate: 'Ngày Thông Báo',
    recordDate: 'Ngày ĐKCC',
    exRigth: 'Ngày GDKHQ',
    excersise: 'Ngày Thực Hiện',
  },
  all: 'Tất Cả',
  ern: 'Lợi Nhuận',
  div: 'Cổ Tức',
  sis: 'Phát Hành Cổ Phiếu',
  ipo: 'Niêm Yết',
  agm: 'Đại Hội Cổ Đông Thường Niên',
  eventType: 'Loại Sự Kiện',
  anDate: 'Ngày Thông Báo',
  recordDate: 'Ngày ĐKCC',
  exRightDate: 'Ngày GDKHQ',
  excerciseDate: 'Ngày Thực Hiện',
  apply: 'Áp Dụng',
  reset: 'Làm Mới',
  to: 'Đến',
  notAvailable: 'Không Có URL',
  startDate: 'NGÀY BẮT ĐẦU',
  endDate: 'NGÀY KẾT THÚC',
};
